<template>
  <div v-if="body_show" class="page flex-col">
    <div class="section_1 flex-col">
      <div class="text-wrapper_141 flex-row">
        <span class="text_3">{{ data.extra['姓名'] }}</span>
      </div>
      <div class="section_16 flex-row">
        <img
          class="thumbnail_102"
          referrerpolicy="no-referrer"
          src="@/assets/ceping114/thumbnail_102.png"
        />
        <span class="text_4">{{ data.extra['性别'] }}</span>
        <em class="thumbnail_5"></em>
        <img
          class="thumbnail_103"
          referrerpolicy="no-referrer"
          src="@/assets/ceping114/thumbnail_103.png"
        />
        <span class="text_5">{{ data.extra['身份2'] }}{{ data.extra['身份3'] }}</span>
      </div>
      <div class="section_17 flex-row">
        <div class="image-text_221 flex-row justify-between">
          <img
            class="thumbnail_104"
            referrerpolicy="no-referrer"
            src="@/assets/ceping114/thumbnail_104.png"
          />
          <span class="text-group_1">{{ data.extra['所在省市'] }}</span>
        </div>
      </div>
      <div class="section_18 flex-row">
        <div class="block_1 flex-row">
          <div class="image-text_222 flex-row justify-between">
            <img
              class="thumbnail_105"
              referrerpolicy="no-referrer"
              src="@/assets/ceping114/thumbnail_105.png"
            />
            <span class="text-group_2">测评日期：{{ data.ctime }}</span>
          </div>
        </div>
        <img src="@/assets/ceping114/section_1_stamp.png" class="stamp" />
      </div>
      <div v-if="data.assessment_code" class="assessment-code">已使用测评码：{{ data.assessment_code }}</div>
    </div>
    <div class="text-wrapper_18 flex-col">
        <TitleBubble text="测评介绍" />
        <span class="text_80"
          >本报告基于MBTI性格理论，立足中国青少年实际学习场景，根据MBTI性格测评结果，为你提供个性化的学习辅导策略。报告中会清晰解释你的学习特质，并根据性格类型制定具体的学习提升计划。通过本报告，能够为你设定短期和长期的辅导目标，提升学习效果，并有效增强家长对孩子学习的支持。</span
        >
      </div>
    <div class="section_2 flex-col">
      <TitleBubble text="注意事项" />
      <span class="text_6"
        >为了有效地运用本次测评报告结果，请注意以下事项：</span
      >
      <div class="text-wrapper_142 flex-row justify-between">
        <img class="text_7" src="@/assets/ceping114/1.png" /> <span class="text_8">类型无优劣之分</span>
      </div>
      <span class="text_9"
        >学习特质类型没有所谓的“好”或“坏”。每种类型都有其独特的价值，在不同的情境中能够发挥不同的作用。</span
      >
      <div class="text-wrapper_143 flex-row justify-between">
        <img class="text_10" src="@/assets/ceping114/2.png" />
        <span class="text_11">探索与理解自我</span>
      </div>
      <span class="text_12"
        >测评结果的意义在于帮助你更好地了解自己，从而改进学习方式，增进与他人的沟通和协作，而不是简单地将自己归类为某种类型。 </span
      >
      <div class="text-wrapper_144 flex-row justify-between">
        <img class="text_13" src="@/assets/ceping114/3.png" />
        <span class="text_14">发展的动态性</span>
      </div>
      <span class="text_15"
        >人的性格特质会随着经历和环境的变化而调整，测评仅提供一个时点上的参考，未来的成长和变化同样重要。</span
      >
      <div class="text-wrapper_145 flex-row justify-between">
        <img class="text_16" src="@/assets/ceping114/4.png" />
        <span class="text_17">测评结果的局限性</span>
      </div>
      <span class="text_18"
        >测评结果反映的是偏好和倾向，而非能力或潜力。请不要将结果作为评估自身学习能力或社交能力的唯一依据。</span
      >
      <div class="text-wrapper_146 flex-row justify-between">
        <img class="text_19" src="@/assets/ceping114/5.png" />
        <span class="text_20">类型不是限制</span>
      </div>
      <span class="text_21"
        >测评结果旨在提供一种新的理解方式，而不是给自己设限。请保持尝试新事物和接受新挑战的开放心态，不让类型认知成为固定思维的框架。 </span
      >
      <div class="text-wrapper_147 flex-row justify-between">
        <img class="text_22" src="@/assets/ceping114/6.png" />
        <span class="text_23">多元化参考</span>
      </div>
      <span class="text_24"
        >本次测评结果仅供参考，建议结合其他测评工具或咨询专业人士，从多个角度深入了解自己，以获得更全面的认识。</span
      >
      <div class="text-wrapper_148 flex-row justify-between">
        <img class="text_25" src="@/assets/ceping114/7.png" />
        <span class="text_26">保持开放性</span>
      </div>
      <span class="text_27"
        >测评是一种探索工具而非绝对答案。理解自己的同时，也要留意多种可能性，接受不同的观点和经验带来的启发。</span
      >
    </div>
    <div class="section_3 flex-col">
      <TitleBubble text="测评模型" />
      <span class="text_29"
        >本测评应用MBTI理论，分别从能量、信息、决策、生活方式4个维度评估学生的性格类型，从而了解你的学习特质。</span
      >
      <span class="text_30">MBTI四个维度</span>
      <div class="block_23">
        <img class="model" src="@/assets/ceping114/section_3_model.png">
      </div>
    </div>
    <div class="section_4 flex-col">
      <div class="box_63 flex-row justify-between">
        <img
          class="thumbnail_9"
          referrerpolicy="no-referrer"
          src="@/assets/ceping114/thumbnail_9_10_27_28.png"
        />
        <div class="image-text_223 flex-row justify-between">
          <span class="text-group_3">测评结果解读</span>
          <img
            class="thumbnail_10"
            referrerpolicy="no-referrer"
            src="@/assets/ceping114/thumbnail_9_10_27_28.png"
          />
        </div>
      </div>
      <div class="group_12 flex-col">
        <TitleBubble text="性格类型分析" />
        <span class="text_39">你的性格类型是：</span>
        <div class="list_12 flex-row">
          <div
            class="image-text_224 flex-col"
            v-for="(item, index) in result"
            :key="index"
          >
            <div
              class="text-wrapper_150 flex-col"
              :style="{ background: item.bg1 }"
            >
              <span class="text_151" v-html="item.text0"></span>
            </div>
            <span class="text-group_149" v-html="item.text1"></span>
          </div>
        </div>
        <ResultChart :scores="data.score_map" />
        <span class="text_65"
          >{{ data.report }}</span
        >
        <div class="box_10 flex-row">
          <span class="text_66"
            >提示：特别关注每个维度下相反特质得分的差异是否显著，例如I（内倾）与E（外倾）的差异是否大，差异大说明特征明显。</span
          >
          <img
            class="thumbnail_11"
            referrerpolicy="no-referrer"
            src="@/assets/ceping114/thumbnail_11_24.png"
          />
        </div>
      </div>
      <div class="group_14 flex-col">
        <TitleBubble text="学习特征分析" />
        <span class="text_67">你学习上的特点如下：</span>
        <template v-for="(text) in data.results1">
          <BulletPoint :content="text" />
        </template>
      </div>
      <div class="group_15 flex-col">
        <TitleBubble text="学习策略改进建议" />

        <span class="text_72"
          >根据你的学习特质，有以下一些策略，可以有效帮助你提升学习效率，获得更好的成绩</span
        >
        
        <template v-for="(text) in data.results2">
          <BulletPoint :content="text" />
        </template>

        <div class="block_4 flex-row">
          <div class="image-text_239 flex-row justify-between">
            <img
              class="thumbnail_24"
              referrerpolicy="no-referrer"
              src="@/assets/ceping114/thumbnail_11_24.png"
            />
            <span class="text-group_23"
              >更多改进建议可联系你的学习力指导师获取。</span
            >
          </div>
        </div>
      </div>
    </div>
    <div class="section_6 flex-col">
      <div class="box_64 flex-row justify-between">
        <img
          class="thumbnail_27"
          referrerpolicy="no-referrer"
          src="@/assets/ceping114/thumbnail_9_10_27_28.png"
        />
        <div class="image-text_240 flex-row justify-between">
          <span class="text-group_26">结语</span>
          <img
            class="thumbnail_28"
            referrerpolicy="no-referrer"
            src="@/assets/ceping114/thumbnail_9_10_27_28.png"
          />
        </div>
      </div>
      <span class="paragraph_1"
        >
        本报告旨在帮助你更好地认识自己、发掘潜力，并找到适合自己的学习方法。通过对性格特质、学习优势与挑战的深入分析，以及辅导建议和未来规划的结合，你能够一步步制定更加适合自己的学习提升方案。<br /><br />
        请记住，学习力的提升是一个持续成长的过程，而每一步的努力都会为未来积累能量。在这个过程中，你不仅会提升细节管理、时间管理和合作学习能力，更会逐渐发现自己的无限可能。无论目前面临怎样的挑战，只要坚持探索、调整策略并拥抱变化，你一定能够取得进步。<br /><br />
        未来的路上，不必追求完美，但要保持前行的信心。相信自己，每一次小小的突破，都是迈向成功的重要一步。愿你在学习的旅程中始终充满希望，勇于尝试，拥抱成长，不断超越自我！最终，你将用自己的努力和智慧，书写属于你的精彩篇章！
        </span
      >
    </div>
    <span class="text_79"
      >本测评由新精英生涯（北京）教育科技有限公司版权所有，违者必究。</span
    >
  </div>
</template>
<script>
import { ceping113_report } from "@/api/measurement";
import TitleBubble from "./title-bubble.vue";
import BulletPoint from "./bullet-point.vue";
import ResultChart from "./result-chart.vue";

export default {
  data() {
    return {
      scores: {
        E: 8.2,
        I: 9.2,
        S: 1.8,
        N: 0.2,
        T: 1.1,
        F: 0.7,
        J: 11,
        P: 8,
      },
      result: [
        {
          bg1: 'rgba(253,93,74,1)',
          text0: '',
          text1: '',
        },
        {
          bg1: 'rgba(21,199,182,1)',
          text0: '',
          text1: '',
        },
        {
          bg1: 'rgba(48,119,255,1)',
          text0: '',
          text1: '',
        },
        {
          bg1: 'rgba(255,147,64,1)',
          text0: '',
          text1: '',
        },
      ],
      data:{},
      body_show: false,
      title: "",
    }
  },
  methods: {
    pullData() {
      ceping113_report({
        uid: this.$route.query.uid,
        evaluation_id: this.$route.query.evaluation_id
      }).then(data => {
        if (data.code == 10002) {
          this.$router.push({
            path:'/ceping113',
            query:this.$route.query
          });
        }else if (typeof data !== "string") {
          this.body_show = true;
          this.data = data;

          for(let i = 0; i < 4; i++) {
            this.result[i].text0 = data.result[i];
            this.result[i].text1 = data.results[i];
          }

          document.title = data.headtitle;
          this.title = data.headtitle;
        } else {
          location.href = data;
        }
      });
    }
  },
  created() {
    this.pullData();
  },
  components: {
    TitleBubble,
    BulletPoint,
    ResultChart,
  }
};
</script>
<style lang="scss" scoped>
@import "@s/common.scss";
.assessment-code {
  margin: 0.4rem 0.6rem 0.5rem;
  color: #333;
  font-size: 0.32rem;
  line-height: 1.5;
  overflow-wrap: anywhere;
}



.page {
  background-color: rgba(245, 245, 245, 1);
  position: relative;
  width: 10rem;
  overflow: hidden;
  padding-left: 0;
  padding-right: 0;
  padding-top: 0;
  padding-bottom: 0.934rem;
  .section_1 {
    position: relative;
    overflow: visible;
    background: url('../../../assets/ceping114/section_1_bg_v2.png') 100% no-repeat;
    background-size: 100%;
    background-position: 0 -2.34rem;
    padding-left: 0.187rem;

    .stamp {
      position: absolute;
      z-index: 1;
      width: 2.13rem;
      height: 2.13rem;
      right: 0.32rem;
      bottom: -0.8rem;
    }

    .section_14 {
      width: 9.067rem;
      align-self: center;
      .text_146 {
        overflow-wrap: break-word;
        color: rgba(0, 0, 0, 1);
        font-size: 0.4rem;
        letter-spacing: -0.30000001192092896px;
        font-weight: normal;
        text-align: right;
        white-space: nowrap;
        line-height: 0.56rem;
      }
      .thumbnail_99 {
        width: 0.454rem;
        height: 0.294rem;
        margin: 0.16rem 0 0.107rem 5.84rem;
      }
      .thumbnail_100 {
        width: 0.4rem;
        height: 0.294rem;
        margin: 0.134rem 0 0.134rem 0.134rem;
      }
      .image_12 {
        width: 0.667rem;
        height: 0.32rem;
        margin: 0.134rem 0 0.107rem 0.134rem;
      }
    }
    .section_15 {
      margin: 0.294rem 0 0 0.24rem;
      .label_12 {
        width: 0.8rem;
        height: 0.64rem;
        margin: 0.267rem 0 0.267rem 0;
      }
      .text_147 {
        overflow-wrap: break-word;
        color: rgba(0, 0, 0, 1);
        font-size: 0.453rem;
        font-weight: 500;
        text-align: right;
        white-space: nowrap;
        line-height: 0.64rem;
        margin: 0.267rem 0 0 1.44rem;
      }
      .group_82 {
        background-color: rgba(216, 216, 216, 0);
        width: 0.107rem;
        height: 0.16rem;
        margin: 0.427rem 0 0.587rem 0.027rem;
      }
      .image-wrapper_1 {
        background-size: 100% 100%;
        margin-left: 0.934rem;
        padding: 0.534rem 0.507rem 0.534rem 0.294rem;
        .thumbnail_101 {
          width: 0.48rem;
          height: 0.107rem;
        }
      }
    }
    .text-wrapper_141 {
      margin: 1.04rem 0.64rem 0 0.64rem;
      .text_3 {
        overflow-wrap: break-word;
        color: rgba(6, 16, 41, 0.7);
        font-size: 0.746rem;
        font-weight: bolder;
        text-align: left;
        white-space: nowrap;
        line-height: 1.067rem;
      }
    }
    .section_16 {
      margin: 0.107rem 0.667rem 0 0.667rem;
      align-items: center;
      .thumbnail_102 {
        width: 0.32rem;
        height: 0.32rem;
      }
      .text_4 {
        overflow-wrap: break-word;
        color: rgba(6, 16, 41, 0.7);
        font-size: 0.32rem;
        font-weight: normal;
        text-align: left;
        white-space: nowrap;
        line-height: 0.454rem;
        margin-left: 0.134rem;
      }
      .thumbnail_5 {
        display: inline-block;
        width: 0.027rem;
        height: 0.214rem;
        background-color: rgba(6, 16, 41, 0.1);
        margin: 0.134rem 0 0.107rem 0.187rem;
      }
      .thumbnail_103 {
        width: 0.32rem;
        height: 0.32rem;
        margin-left: 0.214rem;
      }
      .text_5 {
        overflow-wrap: break-word;
        color: rgba(6, 16, 41, 0.7);
        font-size: 0.32rem;
        font-weight: normal;
        text-align: left;
        white-space: nowrap;
        line-height: 0.454rem;
        margin-left: 0.107rem;
      }
    }
    .section_17 {
      margin: 0.187rem 0.667rem 0 0.667rem;
      .image-text_221 {
        align-items: center;
        .thumbnail_104 {
          width: 0.32rem;
          height: 0.32rem;
        }
        .text-group_1 {
          overflow-wrap: break-word;
          color: rgba(6, 16, 41, 0.7);
          font-size: 0.32rem;
          font-weight: normal;
          text-align: left;
          white-space: nowrap;
          line-height: 0.454rem;
          margin-left: 0.134rem;
        }
      }
    }
    .section_18 {
      margin: 0.267rem 1.707rem 0 0;
      .block_1 {
        background-size: 10rem 92rem;
        .image-text_222 {
          margin: -0.054rem 0.667rem 1.28rem 0.667rem;
          align-items: center;
          .thumbnail_105 {
            width: 0.32rem;
            height: 0.32rem;
          }
          .text-group_2 {
            overflow-wrap: break-word;
            color: rgba(6, 16, 41, 0.7);
            font-size: 0.32rem;
            font-weight: normal;
            text-align: left;
            white-space: nowrap;
            line-height: 0.454rem;
            margin-left: 0.134rem;
          }
        }
      }
    }
  }
  .section_2 {
    background-color: rgba(255, 255, 255, 1);
    border-radius: 16px;
    position: relative;
    width: 9.147rem;
    align-self: center;
    margin-top: 0.854rem;
    padding: 0.8rem 0.427rem 0.427rem 0.427rem;
    .text_6 {
      overflow-wrap: break-word;
      color: rgba(6, 16, 41, 0.7);
      font-size: 0.32rem;
      font-weight: normal;
      text-align: justify;
      white-space: nowrap;
      line-height: 0.534rem;
      margin-right: 0.614rem;
    }
    .text-wrapper_142 {
      width: 2.907rem;
      margin-top: 0.32rem;
      align-items: baseline;
      .text_7 {
        width: 0.11rem;
        height: 0.29rem;
      }
      .text_8 {
        overflow-wrap: break-word;
        color: rgba(51, 51, 51, 1);
        font-size: 0.373rem;
        font-weight: bold;
        text-align: left;
        white-space: nowrap;
        line-height: 0.427rem;
        margin-top: 0.054rem;
      }
    }
    .text_9 {
      width: 8.294rem;
      overflow-wrap: break-word;
      color: rgba(6, 16, 41, 0.7);
      font-size: 0.32rem;
      font-weight: normal;
      text-align: justify;
      line-height: 0.534rem;
      margin-top: 0.187rem;
    }
    .text-wrapper_143 {
      width: 2.907rem;
      margin: 0.427rem 5.36rem 0 0.027rem;
      align-items: baseline;
      .text_10 {
        width: 0.19rem;
        height: 0.29rem;
      }
      .text_11 {
        overflow-wrap: break-word;
        color: rgba(51, 51, 51, 1);
        font-size: 0.373rem;
        font-weight: bold;
        text-align: left;
        white-space: nowrap;
        line-height: 0.427rem;
        margin-top: 0.027rem;
      }
    }
    .text_12 {
      width: 8.294rem;
      overflow-wrap: break-word;
      color: rgba(6, 16, 41, 0.7);
      font-size: 0.32rem;
      font-weight: normal;
      text-align: justify;
      line-height: 0.534rem;
      margin-top: 0.187rem;
    }
    .text-wrapper_144 {
      width: 2.534rem;
      margin: 0.427rem 5.36rem 0 0.027rem;
      align-items: baseline;
      .text_13 {
        width: 0.19rem;
        height: 0.29rem;
      }
      .text_14 {
        overflow-wrap: break-word;
        color: rgba(51, 51, 51, 1);
        font-size: 0.373rem;
        font-weight: bold;
        text-align: left;
        white-space: nowrap;
        line-height: 0.427rem;
        margin-top: 0.027rem;
      }
    }
    .text_15 {
      width: 8.294rem;
      overflow-wrap: break-word;
      color: rgba(6, 16, 41, 0.7);
      font-size: 0.32rem;
      font-weight: normal;
      text-align: justify;
      line-height: 0.534rem;
      margin-top: 0.187rem;
    }
    .text-wrapper_145 {
      width: 3.28rem;
      margin: 0.427rem 5.36rem 0 0.027rem;
      align-items: baseline;
      .text_16 {
        width: 0.19rem;
        height: 0.29rem;
      }
      .text_17 {
        overflow-wrap: break-word;
        color: rgba(51, 51, 51, 1);
        font-size: 0.373rem;
        font-weight: bold;
        text-align: left;
        white-space: nowrap;
        line-height: 0.427rem;
        margin-top: 0.027rem;
      }
    }
    .text_18 {
      width: 8.294rem;
      overflow-wrap: break-word;
      color: rgba(6, 16, 41, 0.7);
      font-size: 0.32rem;
      font-weight: normal;
      text-align: justify;
      line-height: 0.534rem;
      margin-top: 0.187rem;
    }
    .text-wrapper_146 {
      width: 2.534rem;
      margin: 0.427rem 4.987rem 0 0.027rem;
      align-items: baseline;
      .text_19 {
        width: 0.19rem;
        height: 0.29rem;
      }
      .text_20 {
        overflow-wrap: break-word;
        color: rgba(51, 51, 51, 1);
        font-size: 0.373rem;
        font-weight: bold;
        text-align: left;
        white-space: nowrap;
        line-height: 0.427rem;
        margin-top: 0.027rem;
      }
    }
    .text_21 {
      width: 8.294rem;
      overflow-wrap: break-word;
      color: rgba(6, 16, 41, 0.7);
      font-size: 0.32rem;
      font-weight: normal;
      text-align: justify;
      line-height: 0.534rem;
      margin-top: 0.187rem;
    }
    .text-wrapper_147 {
      width: 2.134rem;
      margin: 0.427rem 5.734rem 0 0.027rem;
      align-items: baseline;
      .text_22 {
        width: 0.19rem;
        height: 0.29rem;
      }
      .text_23 {
        overflow-wrap: break-word;
        color: rgba(51, 51, 51, 1);
        font-size: 0.373rem;
        font-weight: bold;
        text-align: left;
        white-space: nowrap;
        line-height: 0.427rem;
        margin-top: 0.027rem;
      }
    }
    .text_24 {
      width: 8.294rem;
      overflow-wrap: break-word;
      color: rgba(6, 16, 41, 0.7);
      font-size: 0.32rem;
      font-weight: normal;
      text-align: justify;
      line-height: 0.534rem;
      margin-top: 0.187rem;
    }
    .text-wrapper_148 {
      width: 2.134rem;
      margin: 0.427rem 6.134rem 0 0.027rem;
      align-items: baseline;

      .text_25 {
        width: 0.16rem;
        height: 0.29rem;
      }
      .text_22 {
        width: 0.19rem;
        height: 0.29rem;
      }
      .text_26 {
        overflow-wrap: break-word;
        color: rgba(51, 51, 51, 1);
        font-size: 0.373rem;
        font-weight: bold;
        text-align: left;
        white-space: nowrap;
        line-height: 0.427rem;
        margin-top: 0.027rem;
      }
    }
    .text_27 {
      width: 8.294rem;
      overflow-wrap: break-word;
      color: rgba(6, 16, 41, 0.7);
      font-size: 0.32rem;
      font-weight: normal;
      text-align: justify;
      line-height: 0.534rem;
      margin-top: 0.187rem;
    }
    .text-wrapper_9 {
      background-color: rgba(12, 83, 252, 1);
      height: 1.6rem;
      width: 2.854rem;
      position: absolute;
      left: 0;
      top: -0.506rem;
      padding: 0.134rem 0.48rem 0.8rem 0.48rem;
      .text_28 {
        overflow-wrap: break-word;
        color: rgba(254, 254, 251, 1);
        font-size: 0.48rem;
        font-weight: normal;
        text-align: left;
        white-space: nowrap;
        line-height: 0.667rem;
      }
    }
  }
  .section_3 {
    background-color: rgba(255, 255, 255, 1);
    border-radius: 16px;
    position: relative;
    width: 9.147rem;
    align-self: center;
    margin-top: 0.854rem;
    padding: 0.8rem 0.427rem 0.427rem 0.427rem;
    .text_29 {
      width: 8.294rem;
      height: 1.067rem;
      overflow-wrap: break-word;
      color: rgba(6, 16, 41, 0.7);
      font-size: 0.32rem;
      font-weight: normal;
      text-align: justify;
      line-height: 0.534rem;
    }
    .text_30 {
      overflow-wrap: break-word;
      color: rgba(51, 51, 51, 1);
      font-size: 0.426rem;
      font-weight: bold;
      text-align: left;
      white-space: nowrap;
      line-height: 0.587rem;
      margin: 0.32rem 5.6rem 0 0;
    }
    .block_23 {
      margin-top: 0.32rem;
      .model {
        width: 8.32rem;
        height: 4.27rem;
      }
      .text_31 {
        overflow-wrap: break-word;
        color: rgba(12, 83, 252, 1);
        font-size: 0.373rem;
        font-weight: bold;
        text-align: justify;
        white-space: nowrap;
        line-height: 0.534rem;
      }
      .group_8 {
        width: 0.854rem;
        height: 0.214rem;
        background-size: 100% 100%;
        margin: 0.187rem 0 0.134rem 0.267rem;
      }
      .text_32 {
        overflow-wrap: break-word;
        color: rgba(12, 83, 252, 1);
        font-size: 0.373rem;
        font-weight: bold;
        text-align: justify;
        white-space: nowrap;
        line-height: 0.534rem;
        margin-left: 0.267rem;
      }
      .group_9 {
        width: 0.854rem;
        height: 0.214rem;
        background-size: 100% 100%;
        margin: 0.187rem 0 0.134rem 0.267rem;
      }
      .text_33 {
        overflow-wrap: break-word;
        color: rgba(12, 83, 252, 1);
        font-size: 0.373rem;
        font-weight: bold;
        text-align: justify;
        white-space: nowrap;
        line-height: 0.534rem;
        margin-left: 0.294rem;
      }
      .group_10 {
        width: 0.854rem;
        height: 0.214rem;
        background-size: 100% 100%;
        margin: 0.187rem 0 0.134rem 0;
      }
      .text_34 {
        overflow-wrap: break-word;
        color: rgba(12, 83, 252, 1);
        font-size: 0.373rem;
        font-weight: bold;
        text-align: justify;
        white-space: nowrap;
        line-height: 0.534rem;
        margin-left: 0.16rem;
      }
    }
    .grid_12 {
      width: 8.294rem;
      height: 3.414rem;
      margin-top: 0.32rem;
      flex-wrap: wrap;
      .list-items_12 {
        border-radius: 4px;
        width: 1.867rem;
        height: 1.6rem;
        margin: 0 0.267rem 0.214rem 0;
        padding: 0.347rem 0.08rem 0.347rem 0.214rem;
        .text-wrapper_149 {
          width: 1.067rem;
          margin-right: 0.507rem;
          .text_148 {
            width: 0.427rem;
            overflow-wrap: break-word;
            color: rgba(255, 255, 255, 1);
            font-size: 0.533rem;
            font-weight: bold;
            text-align: justify;
            white-space: nowrap;
            line-height: 0.534rem;
          }
          .text_149 {
            overflow-wrap: break-word;
            color: rgba(255, 255, 255, 1);
            font-size: 0.32rem;
            font-weight: bold;
            text-align: justify;
            white-space: nowrap;
            line-height: 0.454rem;
            margin-top: 0.08rem;
          }
        }
        .text_150 {
          width: 1.574rem;
          overflow-wrap: break-word;
          color: rgba(255, 255, 255, 1);
          font-size: 0.266rem;
          font-weight: normal;
          text-align: justify;
          white-space: nowrap;
          line-height: 0.374rem;
        }
      }
    }
    .text-wrapper_11 {
      background-color: rgba(12, 83, 252, 1);
      height: 1.6rem;
      width: 2.854rem;
      position: absolute;
      left: 0;
      top: -0.426rem;
      padding: 0.134rem 0.48rem 0.8rem 0.48rem;
      .text_38 {
        overflow-wrap: break-word;
        color: rgba(254, 254, 251, 1);
        font-size: 0.48rem;
        font-weight: normal;
        text-align: left;
        white-space: nowrap;
        line-height: 0.667rem;
      }
    }
  }
  .section_4 {
    background-color: rgba(255, 255, 255, 1);
    border-radius: 16px;
    position: relative;
    width: 9.147rem;
    align-self: center;
    margin-top: 0.427rem;
    padding: 0.427rem 0.427rem 0.427rem 0.427rem;
    .box_63 {
      width: 4.08rem;
      align-self: center;
      .thumbnail_9 {
        width: 0.267rem;
        height: 0.24rem;
        margin: 0.24rem 0 0.267rem 0;
      }
      .image-text_223 {
        width: 3.627rem;
        .text-group_3 {
          overflow-wrap: break-word;
          color: rgba(6, 16, 41, 1);
          font-size: 0.533rem;
          font-weight: bolder;
          text-align: left;
          white-space: nowrap;
          line-height: 0.747rem;
        }
        .thumbnail_10 {
          width: 0.267rem;
          height: 0.24rem;
          margin: 0.24rem 0 0.267rem 0;
        }
      }
    }
    .group_12 {
      margin-top: 0.72rem;
      padding: 0.8rem 0.24rem 0.427rem 0.267rem;
      position: relative;
      border-radius: 0.43rem;
      background: linear-gradient(180deg, #F2F9FF 0%, #FFFFFF 10%);

      &:before {
        content: '';
        position: absolute;
        inset: 0;
        border-radius: 0.43rem;
        padding: 1px;
        background: linear-gradient(180deg, rgba(249, 250, 255, 1), rgba(240, 243, 255, 1));
        -webkit-mask: 
          linear-gradient(#fff 0 0) content-box,
          linear-gradient(#fff 0 0);
        mask-composite: exclude;
      }

      .text_39 {
        overflow-wrap: break-word;
        color: rgba(51, 51, 51, 1);
        font-size: 0.426rem;
        font-weight: bold;
        text-align: left;
        white-space: nowrap;
        line-height: 0.587rem;
        margin: 0 4.347rem 0 0.08rem;
      }
      .list_12 {
        width: 7.787rem;
        height: 1.494rem;
        margin-top: 0.427rem;
        justify-content: space-between;
        .image-text_224 {
          background-color: #F5F5F5;
          border-radius: 0.1rem;

          .text-wrapper_150 {
            width: 1.75rem;
            border-radius: 0.1rem 0.1rem 0 0;
            text-align: center;
            .text_151 {
              color: rgba(255, 255, 255, 1);
              font-size: 0.48rem;
              font-weight: 500;
              white-space: nowrap;
              line-height: 0.745rem;
            }
          }
          .text-group_149 {
            width: 1.75rem;
            color: rgba(51, 51, 51, 1);
            font-size: 0.373rem;
            font-weight: bold;
            text-align: center;
            white-space: nowrap;
            line-height: 0.745rem;
          }
        }
      }
      .text_65 {
        width: 7.44rem;
        overflow-wrap: break-word;
        color: rgba(6, 16, 41, 0.7);
        font-size: 0.32rem;
        font-weight: normal;
        text-align: justify;
        line-height: 0.534rem;
        margin: 0.427rem 0.187rem 0 0.16rem;
      }
      .box_10 {
        background-color: rgba(245, 245, 245, 1);
        border-radius: 0.21rem;
        position: relative;
        margin: 0.427rem 0.187rem 0 0.16rem;
        padding: 0.214rem 0.32rem 0.214rem 0.32rem;
        .text_66 {
          width: 6.8rem;
          overflow-wrap: break-word;
          color: rgba(6, 16, 41, 0.7);
          font-size: 0.32rem;
          font-weight: normal;
          text-align: left;
          line-height: 0.534rem;
          text-indent: 1.5em;
        }
        .thumbnail_11 {
          position: absolute;
          left: 0.32rem;
          top: 0.32rem;
          width: 0.32rem;
          height: 0.32rem;
        }
      }
    }
    .group_14 {
      margin-top: 0.907rem;
      padding: 0.8rem 0.427rem 0.427rem 0.427rem;
      gap: 0.427rem;
      position: relative;
      border-radius: 0.43rem;
      background: linear-gradient(180deg, #F2F9FF 0%, #FFFFFF 10%);

      &:before {
        content: '';
        position: absolute;
        inset: 0;
        border-radius: 0.43rem;
        padding: 1px;
        background: linear-gradient(180deg, rgba(249, 250, 255, 1), rgba(240, 243, 255, 1));
        -webkit-mask: 
          linear-gradient(#fff 0 0) content-box,
          linear-gradient(#fff 0 0);
        mask-composite: exclude;
      }

      .text_67 {
        color: rgba(51, 51, 51, 1);
        font-size: 0.426rem;
        font-weight: bold;
        text-align: left;
        white-space: nowrap;
        line-height: 0.587rem;
      }
      .image-text_225 {
        width: 2rem;
        margin: 0.294rem 5.44rem 0 0;
        .thumbnail_12 {
          width: 0.187rem;
          height: 0.214rem;
          margin: 0.107rem 0 0.107rem 0;
        }
        .text-group_11 {
          overflow-wrap: break-word;
          color: rgba(51, 51, 51, 1);
          font-size: 0.32rem;
          font-weight: 500;
          text-align: left;
          white-space: nowrap;
          line-height: 0.427rem;
        }
      }
      .image-text_226 {
        width: 2.934rem;
        margin: 0.427rem 4.507rem 0 0;
        .thumbnail_13 {
          width: 0.187rem;
          height: 0.214rem;
          margin: 0.107rem 0 0.107rem 0;
        }
        .text-group_12 {
          overflow-wrap: break-word;
          color: rgba(51, 51, 51, 1);
          font-size: 0.32rem;
          font-weight: 500;
          text-align: left;
          white-space: nowrap;
          line-height: 0.427rem;
        }
      }
      .image-text_227 {
        width: 3.254rem;
        margin: 0.427rem 4.187rem 0 0;
        .thumbnail_14 {
          width: 0.187rem;
          height: 0.214rem;
          margin: 0.107rem 0 0.107rem 0;
        }
        .text-group_13 {
          overflow-wrap: break-word;
          color: rgba(51, 51, 51, 1);
          font-size: 0.32rem;
          font-weight: 500;
          text-align: left;
          white-space: nowrap;
          line-height: 0.427rem;
        }
      }
      .image-text_228 {
        width: 7.44rem;
        margin-top: 0.427rem;
        .thumbnail_15 {
          width: 0.187rem;
          height: 0.214rem;
          margin: 1.6rem 0 0.107rem 0;
        }
        .text-group_156 {
          .text_68 {
            width: 7.04rem;
            height: 1.067rem;
            overflow-wrap: break-word;
            color: rgba(51, 51, 51, 1);
            font-size: 0.32rem;
            font-weight: 500;
            text-align: left;
            line-height: 0.534rem;
          }
          .text_69 {
            overflow-wrap: break-word;
            color: rgba(51, 51, 51, 1);
            font-size: 0.32rem;
            font-weight: 500;
            text-align: left;
            white-space: nowrap;
            line-height: 0.427rem;
            margin: 0.427rem 2.614rem 0 0;
          }
        }
      }
      .image-text_229 {
        width: 7.44rem;
        margin-top: 0.427rem;
        .thumbnail_16 {
          width: 0.187rem;
          height: 0.214rem;
          margin: 1.6rem 0 0.107rem 0;
        }
        .text-group_157 {
          .text_70 {
            width: 7.04rem;
            height: 1.067rem;
            overflow-wrap: break-word;
            color: rgba(51, 51, 51, 1);
            font-size: 0.32rem;
            font-weight: 500;
            text-align: left;
            line-height: 0.534rem;
          }
          .text_71 {
            overflow-wrap: break-word;
            color: rgba(51, 51, 51, 1);
            font-size: 0.32rem;
            font-weight: 500;
            text-align: left;
            white-space: nowrap;
            line-height: 0.427rem;
            margin: 0.427rem 2.934rem 0 0;
          }
        }
      }
      .image-text_230 {
        width: 3.867rem;
        margin: 0.427rem 3.574rem 0 0;
        .thumbnail_17 {
          width: 0.187rem;
          height: 0.214rem;
          margin: 0.107rem 0 0.107rem 0;
        }
        .text-group_16 {
          overflow-wrap: break-word;
          color: rgba(51, 51, 51, 1);
          font-size: 0.32rem;
          font-weight: 500;
          text-align: left;
          white-space: nowrap;
          line-height: 0.427rem;
        }
      }
      .image-text_231 {
        width: 7.44rem;
        margin-top: 0.427rem;
        .thumbnail_18 {
          width: 0.187rem;
          height: 0.214rem;
          margin: 0.16rem 0 0.694rem 0;
        }
        .text-group_17 {
          width: 7.04rem;
          height: 1.067rem;
          overflow-wrap: break-word;
          color: rgba(51, 51, 51, 1);
          font-size: 0.32rem;
          font-weight: 500;
          text-align: left;
          line-height: 0.534rem;
        }
      }
      .image-text_232 {
        position: absolute;
        left: 0.427rem;
        top: 4.24rem;
        width: 7.44rem;
        height: 1.92rem;
        .thumbnail_19 {
          width: 0.187rem;
          height: 0.214rem;
          margin: 0.134rem 0 1.574rem 0;
        }
        .text-group_158 {
          .text_68 {
            width: 7.04rem;
            height: 1.067rem;
            overflow-wrap: break-word;
            color: rgba(51, 51, 51, 1);
            font-size: 0.32rem;
            font-weight: 500;
            text-align: left;
            line-height: 0.534rem;
          }
          .text_69 {
            overflow-wrap: break-word;
            color: rgba(51, 51, 51, 1);
            font-size: 0.32rem;
            font-weight: 500;
            text-align: left;
            white-space: nowrap;
            line-height: 0.427rem;
            margin: 0.427rem 2.614rem 0 0;
          }
        }
      }
      .image-text_233 {
        position: absolute;
        left: 0.427rem;
        top: 6.587rem;
        width: 7.44rem;
        height: 1.92rem;
        .thumbnail_20 {
          width: 0.187rem;
          height: 0.214rem;
          margin: 0.16rem 0 1.547rem 0;
        }
        .text-group_159 {
          .text_70 {
            width: 7.04rem;
            height: 1.067rem;
            overflow-wrap: break-word;
            color: rgba(51, 51, 51, 1);
            font-size: 0.32rem;
            font-weight: 500;
            text-align: left;
            line-height: 0.534rem;
          }
          .text_71 {
            overflow-wrap: break-word;
            color: rgba(51, 51, 51, 1);
            font-size: 0.32rem;
            font-weight: 500;
            text-align: left;
            white-space: nowrap;
            line-height: 0.427rem;
            margin: 0.427rem 2.934rem 0 0;
          }
        }
      }
    }
    .group_15 {
      margin-top: 0.827rem;
      padding: 0.8rem 0.32rem 0.427rem 0.32rem;gap: 0.427rem;
      gap: 0.427rem;
      position: relative;
      border-radius: 0.43rem;
      background: linear-gradient(180deg, #F2F9FF 0%, #FFFFFF 10%);

      &:before {
        content: '';
        position: absolute;
        inset: 0;
        border-radius: 0.43rem;
        padding: 1px;
        background: linear-gradient(180deg, rgba(249, 250, 255, 1), rgba(240, 243, 255, 1));
        -webkit-mask: 
          linear-gradient(#fff 0 0) content-box,
          linear-gradient(#fff 0 0);
        mask-composite: exclude;
      }

      .text_72 {
        width: 7.44rem;
        height: 1.067rem;
        overflow-wrap: break-word;
        color: rgba(6, 16, 41, 0.7);
        font-size: 0.32rem;
        font-weight: normal;
        text-align: justify;
        line-height: 0.534rem;
        align-self: center;
      }
      .image-text_234 {
        width: 6.4rem;
        margin: 0.427rem 1.147rem 0 0.107rem;
        .thumbnail_21 {
          width: 0.187rem;
          height: 0.214rem;
          margin: 0.107rem 0 0.107rem 0;
        }
        .text-group_20 {
          overflow-wrap: break-word;
          color: rgba(51, 51, 51, 1);
          font-size: 0.32rem;
          font-weight: 500;
          text-align: left;
          white-space: nowrap;
          line-height: 0.427rem;
        }
      }
      .image-text_235 {
        width: 7.44rem;
        align-self: center;
        margin-top: 0.427rem;
        .thumbnail_22 {
          width: 0.187rem;
          height: 0.214rem;
          margin: 0.107rem 0 0.534rem 0;
        }
        .text-group_21 {
          width: 7.04rem;
          height: 0.854rem;
          overflow-wrap: break-word;
          color: rgba(51, 51, 51, 1);
          font-size: 0.32rem;
          font-weight: 500;
          text-align: left;
          line-height: 0.427rem;
        }
      }
      .image-text_236 {
        width: 7.44rem;
        align-self: center;
        margin-top: 0.427rem;
        .thumbnail_25 {
          width: 0.187rem;
          height: 0.214rem;
          margin: 0.107rem 0 0.534rem 0;
        }
        .text_73 {
          width: 7.04rem;
          height: 0.854rem;
          overflow-wrap: break-word;
          color: rgba(51, 51, 51, 1);
          font-size: 0.32rem;
          font-weight: 500;
          text-align: left;
          line-height: 0.427rem;
        }
      }
      .image-text_237 {
        width: 7.44rem;
        align-self: center;
        margin-top: 0.427rem;
        .thumbnail_26 {
          width: 0.187rem;
          height: 0.214rem;
          margin: 0.107rem 0 0.534rem 0;
        }
        .text_74 {
          width: 7.04rem;
          height: 0.854rem;
          overflow-wrap: break-word;
          color: rgba(51, 51, 51, 1);
          font-size: 0.32rem;
          font-weight: 500;
          text-align: left;
          line-height: 0.427rem;
        }
      }
      .image-text_238 {
        width: 7.44rem;
        align-self: center;
        margin-top: 0.427rem;
        .thumbnail_23 {
          width: 0.187rem;
          height: 0.214rem;
          margin: 0.16rem 0 0.694rem 0;
        }
        .text_75 {
          width: 7.04rem;
          height: 1.067rem;
          overflow-wrap: break-word;
          color: rgba(51, 51, 51, 1);
          font-size: 0.32rem;
          font-weight: 500;
          text-align: left;
          line-height: 0.534rem;
        }
      }
      .block_4 {
        background-color: rgba(12, 83, 252, 0.1);
        border-radius: 0.21rem;
        padding: 0 0.4rem 0 0.32rem;
        .image-text_239 {
          width: 6.934rem;
          height: 0.96rem;
          align-items: center;
          .thumbnail_24 {
            width: 0.32rem;
            height: 0.32rem;
          }
          .text-group_23 {
            overflow-wrap: break-word;
            color: rgba(6, 16, 41, 0.7);
            font-size: 0.32rem;
            font-weight: normal;
            text-align: left;
            white-space: nowrap;
          }
        }
      }
    }
    .text-wrapper_15 {
      background-color: rgba(12, 83, 252, 1);
      height: 1.44rem;
      width: 3.067rem;
      position: absolute;
      left: 0.427rem;
      top: 1.6rem;
      padding: 0.134rem 0.427rem 0.774rem 0.427rem;
      .text_76 {
        overflow-wrap: break-word;
        color: rgba(254, 254, 251, 1);
        font-size: 0.373rem;
        font-weight: normal;
        text-align: left;
        white-space: nowrap;
        line-height: 0.534rem;
      }
    }
    .text-wrapper_16 {
      background-color: rgba(12, 83, 252, 1);
      height: 1.44rem;
      width: 3.067rem;
      position: absolute;
      left: 0.427rem;
      top: 17.6rem;
      padding: 0.134rem 0.427rem 0.774rem 0.427rem;
      .text_77 {
        overflow-wrap: break-word;
        color: rgba(254, 254, 251, 1);
        font-size: 0.373rem;
        font-weight: normal;
        text-align: left;
        white-space: nowrap;
        line-height: 0.534rem;
      }
    }
    .text-wrapper_17 {
      background-color: rgba(12, 83, 252, 1);
      height: 1.44rem;
      width: 3.867rem;
      position: absolute;
      left: 0.427rem;
      top: 29.787rem;
      padding: 0.134rem 0.48rem 0.774rem 0.427rem;
      .text_78 {
        overflow-wrap: break-word;
        color: rgba(254, 254, 251, 1);
        font-size: 0.373rem;
        font-weight: normal;
        text-align: left;
        white-space: nowrap;
        line-height: 0.534rem;
      }
    }
  }
  .section_6 {
    background-color: rgba(255, 255, 255, 1);
    border-radius: 16px;
    width: 9.147rem;
    align-self: center;
    margin-top: 0.427rem;
    padding: 0.427rem 0.427rem 0.427rem 0.427rem;
    .box_64 {
      width: 1.974rem;
      align-self: center;
      .thumbnail_27 {
        width: 0.267rem;
        height: 0.24rem;
        margin: 0.24rem 0 0.267rem 0;
      }
      .image-text_240 {
        width: 1.52rem;
        .text-group_26 {
          overflow-wrap: break-word;
          color: rgba(6, 16, 41, 1);
          font-size: 0.533rem;
          font-weight: bolder;
          text-align: left;
          white-space: nowrap;
          line-height: 0.747rem;
        }
        .thumbnail_28 {
          width: 0.267rem;
          height: 0.24rem;
          margin: 0.24rem 0 0.267rem 0;
        }
      }
    }
    .paragraph_1 {
      width: 8.294rem;
      overflow-wrap: break-word;
      color: rgba(6, 16, 41, 0.7);
      font-size: 0.32rem;
      font-weight: normal;
      text-align: justify;
      line-height: 0.534rem;
      margin-top: 0.427rem;
    }
  }
  .text_79 {
    overflow-wrap: break-word;
    color: rgba(6, 16, 41, 0.7);
    font-size: 0.266rem;
    font-weight: normal;
    text-align: justify;
    line-height: 0.534rem;
    margin: 0.427rem 0.88rem 0 0.854rem;
  }
  .box_65 {
    position: absolute;
    left: 0;
    top: 8.24rem;
    width: 10rem;
    height: 4.747rem;
    padding-bottom: 2.08rem;
    .block_5 {
      background-color: rgba(245, 245, 245, 1);
      width: 10rem;
      height: 2.667rem;
    }
    .text-wrapper_18 {
      height: 4.427rem;
      background-size: 100% 100%;
      width: 9.147rem;
      position: absolute;
      left: 0.427rem;
      top: -0.64rem;
      padding: 0.8rem 0.427rem 0.427rem 0.427rem;
      .text_80 {
        width: 8.294rem;
        height: 3.2rem;
        overflow-wrap: break-word;
        color: rgba(6, 16, 41, 0.7);
        font-size: 0.32rem;
        font-weight: normal;
        text-align: justify;
        line-height: 0.534rem;
      }
    }
    .text-wrapper_19 {
      background-color: rgba(12, 83, 252, 1);
      height: 1.6rem;
      width: 2.854rem;
      position: absolute;
      left: 0.427rem;
      top: -1.12rem;
      padding: 0.134rem 0.48rem 0.8rem 0.48rem;
      .text_81 {
        overflow-wrap: break-word;
        color: rgba(254, 254, 251, 1);
        font-size: 0.48rem;
        font-weight: normal;
        text-align: left;
        white-space: nowrap;
        line-height: 0.667rem;
      }
    }
    .text-wrapper_20 {
      height: 2.08rem;
      background-size: 2.134rem 2.134rem;
      width: 2.08rem;
      position: absolute;
      left: 7.547rem;
      top: -1.973rem;
      padding: 0.694rem 0.56rem 0.694rem 0.56rem;
      .paragraph_2 {
        width: 0.96rem;
        height: 0.694rem;
        overflow-wrap: break-word;
        color: rgba(254, 49, 49, 1);
        font-size: 0.32rem;
        font-weight: bolder;
        text-align: left;
        line-height: 0.32rem;
      }
    }
  }

  .text-wrapper_18 {
    background-color: rgba(255, 255, 255, 1);
    border-radius: 16px;
    position: relative;
    width: 9.147rem;
    align-self: center;
    padding: 0.8rem 0.427rem 0.427rem 0.427rem;
    .text_80 {
      width: 8.294rem;
      height: 3.2rem;
      overflow-wrap: break-word;
      color: rgba(6, 16, 41, 0.7);
      font-size: 0.32rem;
      font-weight: normal;
      text-align: justify;
      line-height: 0.534rem;
    }
  }
}
</style>